import { Types } from "../actions/actionTypes";
import initialState from "../store/initial-state";
// import fs from 'fs';

//const lastEcgCounters = {};


export const deviceVitalDataReducer = (state = initialState.deviceVitalDataReducer, action) => {
    switch (action.type) {
        case Types.VENTILATOR_HEARTBEAT_DATA: {
            let bedId = action?.payload?.bedId;
            let heartbeat = action?.payload?.isConnected || false;
            let user_enabled = action?.payload?.user_enabled
            if (!bedId) return {
                ...state
            };

            let ventilatorHeartbeatState = state.ventilatorHeartbeat;

            ventilatorHeartbeatState[bedId] = {
                isConnected: heartbeat,
                user_enabled: user_enabled
            }

            return {
                ...state,
                ventilatorHeartbeat: { ...ventilatorHeartbeatState }
            }
        };
        case Types.VENTILATOR_VITAL_DATA: {
            let bedId = action.payload?.bedId;
            let ventilatorId = action.payload?.deviceId;
            let deviceType = action.payload?.deviceType && action.payload?.deviceType.toUpperCase();
            let ventilatorVitalData = action.payload?.monitorsData;

            if (!bedId || !ventilatorId || !ventilatorVitalData) {
                return {
                    ...state
                }
            };

            let vStateData = state.ventilatorVitalData;
            vStateData[bedId] = {
                ...vStateData[bedId],
                bedId: bedId,
                ventilatorId: ventilatorId,
                deviceType: deviceType,
                ventilatorVitalData: ventilatorVitalData
            }

            return {
                ...state,
                ventilatorVitalData: { ...vStateData }
            }
        }
        case Types.VENTILATOR_STANDBY_DATA: {
            let bedId = action.payload.bedId;
            let ventilationStatus = action.payload.ventilationStatus;

            if (!bedId) {
                return {
                    ...state
                }
            };

            let vStateData = state.ventilatorStandby;

            vStateData[bedId] = {
                ...vStateData[bedId],
                bedId: bedId,
                ventilationStatus: ventilationStatus
            }
            return {
                ...state,
                ventilatorStandby: { ...vStateData }
            }
        }

        case Types.VENTILATOR_WAVEFORM_DATA: {
            if (!action.payload) return {
                ...state
            };
            let bedId = action.payload.bedId;
            let ventilatorId = action.payload.deviceId;
            let deviceType = action.payload.deviceType && action.payload.deviceType.toUpperCase();
            let waveformdata = action.payload.waveformdata;
            let observedAt = action.payload.observedAt;
            let packetNumber = action.payload.packetCounter
            if (!bedId || !ventilatorId || !waveformdata) return;
            let vStateWaveformData = state.ventilatorWaveformData || {};


            let currentPacketObservation = observedAt;
            if (vStateWaveformData?.[bedId] && !vStateWaveformData?.[bedId]?.lag) {
                vStateWaveformData[bedId].lag = Date.now() - currentPacketObservation;
                return {
                    ...state
                };
            }
            let currentPacketObservationTime = currentPacketObservation + vStateWaveformData?.[bedId]?.lag;
            let pressurePoints = waveformdata.pressure || [];
            let flowPoints = waveformdata.flow || [];
            let volumePoints = waveformdata.volume || [];

            let pressureStreamArray = [];
            pressurePoints.map((point, i) => {
                if (!isNaN(currentPacketObservationTime) && point !== undefined && point !== null) {
                    pressureStreamArray.push(
                        {
                            x: (currentPacketObservationTime + (1000 / pressurePoints.length) * i),
                            y: point / 100,
                        }
                    )
                }
                return;
            })

            let flowStreamArray = [];
            flowPoints.map((point, i) => {
                if (!isNaN(currentPacketObservationTime) && point !== undefined && point !== null) {
                    flowStreamArray.push(
                        {
                            x: (currentPacketObservationTime + (1000 / flowPoints.length) * i),
                            y: point / 100
                        }
                    )
                }
                // eslint-disable-next-line array-callback-return
                return;
            })

            let volumeStreamArray = [];
            volumePoints.map((point, i) => {
                if (!isNaN(currentPacketObservationTime) && point !== undefined && point !== null) {
                    volumeStreamArray.push(
                        {
                            x: currentPacketObservationTime + (1000 / volumePoints.length) * i,
                            y: point
                        }
                    )
                }
                // eslint-disable-next-line array-callback-return
                return;
            })

            let pressurePointsQueue = vStateWaveformData?.[bedId]?.ventilatorWaveformData?.pressure?.splice(-5500) || [{ x: NaN, y: NaN }];
            let flowPointsQueue = vStateWaveformData?.[bedId]?.ventilatorWaveformData?.flow?.splice(-5500) || [{ x: NaN, y: NaN }];
            let volumePointsQueue = vStateWaveformData?.[bedId]?.ventilatorWaveformData?.volume?.splice(-5500) || [{ x: NaN, y: NaN }];

            vStateWaveformData[bedId] = {
                ...vStateWaveformData[bedId],
                bedId: bedId,
                packetNumber: packetNumber,
                ventilatorId: ventilatorId,
                deviceType: deviceType,
                observedAt: observedAt,
                ventilatorWaveformData: {
                    pressure: [...pressurePointsQueue, ...pressureStreamArray],
                    flow: [...flowPointsQueue, ...flowStreamArray],
                    volume: [...volumePointsQueue, ...volumeStreamArray]
                }
            }
            return {
                ...state,
                ventilatorWaveformData: { ...vStateWaveformData }
            }
        }
        case Types.VENTILATOR_PATIENT_MODE_ALARM_PROFILE_DATA: {
            // console.log("VENTILATOR_PATIENT_MODE_ALARM_PROFILE_DATA--->",action?.payload)
            let payload = action?.payload
            let bedId = payload?.bedId;
            let setParameters = payload?.setParameters || [];
            let modeId = payload?.modeId ?? null;
            let patientType = payload?.patientType || null;
            let patientId = payload?.patientId ?? null;

            let patientName = payload?.patientName ?? null;
            let patientAge = payload?.patientAge ?? null;
            let patientGender = payload?.patientGender ?? null

            if (!bedId || !(setParameters || modeId || patientType || patientId)) {
                return state;
            };
            let vStateData = state.ventilatorPatientModeAlarmProfileData;

            //Check Source of data
            // If the source is API, only update if existing data is null/undefined
            let source = action?.payload?.source;
            if (source === "API") {
                // console.log("BEDID", bedId)
                // console.log("Data in reducer state VENTILATOR_PATIENT_MODE_ALARM_PROFILE_DATA----------->", vStateData?.[bedId])
                if (vStateData?.[bedId]) {
                    return state
                }
            }

            vStateData[bedId] = {
                ...vStateData[bedId],
                bedId: bedId,
                setParameters: setParameters,
                modeId: modeId,
                patientType: patientType,
                patientId: patientId,
                patientName:patientName,
                patientAge: patientAge,
                patientGender: patientGender

            }

            return {
                ...state,
                ventilatorPatientModeAlarmProfileData: { ...vStateData }
            }
        }

        case Types.VENTILATOR_ADDITIONAL_FEATURES_DATA: {
            let bedId = action?.payload?.bedId;
            let additionalFeatures = action?.payload?.additionalFeatures || [];

            if (!bedId || !additionalFeatures) return state;
            let ventilatorAdditionalFeaturesData = state.ventilatorAdditionalFeaturesData;

            //Check Source of data
            // If the source is API, only update if existing data is null/undefined
            let source = action?.payload?.source;
            if (source === "API") {
                // console.log("Data in reducer state----------->", ventilatorAdditionalFeaturesData?.[bedId]?.ventilatorAdditionalFeaturesData)
                if (ventilatorAdditionalFeaturesData?.[bedId]?.ventilatorAdditionalFeaturesData) {
                    return state
                }
            }
            const prevAdditionalFeatures =
                ventilatorAdditionalFeaturesData?.[bedId]?.ventilatorAdditionalFeaturesData;
            if (
                prevAdditionalFeatures &&
                JSON.stringify(prevAdditionalFeatures) === JSON.stringify(additionalFeatures)
            ) {
                return state;
            }
            ventilatorAdditionalFeaturesData[bedId] = {
                ...ventilatorAdditionalFeaturesData[bedId],
                bedId: bedId,
                ventilatorAdditionalFeaturesData: [...additionalFeatures]
            }
            return {
                ...state,
                ventilatorAdditionalFeaturesData: { ...ventilatorAdditionalFeaturesData }
            }
        }

        case Types.VENTILATOR_MODULE_CONNECTION_STATUS_DATA: {
            // console.log("VENTILATOR_MODULE_CONNECTION_STATUS_DATA reducer ---------------->", action.payload);
            let bedId = action?.payload?.bedId;
            let moduleConnectionStatus = action?.payload?.moduleConnectionStatus || {};

            if (!bedId || !moduleConnectionStatus) return state;
            let ventilatorModuleConnectionStatus = state.ventilatorModuleConnectionStatus;

            //Check Source of data
            // If the source is API, only update if existing data is null/undefined
            let source = action?.payload?.source;
            if (source === "API") {
                // console.log("BEDID", bedId)
                // console.log("Data in reducer state VENTILATOR_MODULE_CONNECTION_STATUS_DATA----------->", ventilatorModuleConnectionStatus?.[bedId]?.ventilatorModuleConnectionStatus)
                if (ventilatorModuleConnectionStatus?.[bedId]?.ventilatorModuleConnectionStatus) {
                    return state
                }
            }
            const prevModuleStatus =
                ventilatorModuleConnectionStatus?.[bedId]?.ventilatorModuleConnectionStatus;
            if (
                prevModuleStatus &&
                JSON.stringify(prevModuleStatus) === JSON.stringify(moduleConnectionStatus)
            ) {
                return state;
            }
            ventilatorModuleConnectionStatus[bedId] = {
                ...ventilatorModuleConnectionStatus[bedId],
                bedId: bedId,
                ventilatorModuleConnectionStatus: { ...moduleConnectionStatus }
            }
            return {
                ...state,
                ventilatorModuleConnectionStatus: { ...ventilatorModuleConnectionStatus }
            }
        }

        case Types.MONITOR_HEARTBEAT_DATA: {
            // console.log("MONITOR_HEARTBEAT_DATA---------------->", action.payload);


            let bedId = action.payload.bedId;
            let heartbeat = action.payload?.isConnected || false;
            if (!bedId) return {
                ...state
            };

            let monitorHeartbeatState = state.monitorHeartbeat || {};
            monitorHeartbeatState[bedId] = {
                isConnected: heartbeat
            }

            return {
                ...state,
                monitorHeartbeat: { ...monitorHeartbeatState }
            }

        };


        case Types.DEVICE_VITAL_DATA_ECG: {

            // console.log("DEVICE_VITAL_DATA_ECG---------------->", action.payload);

            let bedId = action.payload.bedId;
            let patientMonitorId = action.payload.deviceId;
            // let dongleId = action.payload.dongleId;
            let deviceType = action?.payload?.deviceType?.toUpperCase();
            let vitals = action.payload.monitorParameter;

            if (!bedId || !patientMonitorId || !vitals) {
                return {
                    ...state
                }
            };


            let deviceVitalDataECG = state.deviceVitalDataECG;
            deviceVitalDataECG[bedId] = {
                ...deviceVitalDataECG[bedId],
                // dongleId: dongleId,
                bedId: bedId,
                [deviceType]: {
                    patientMonitorId: patientMonitorId,
                    deviceType: deviceType,
                    vitals: vitals
                }
            }


            return {
                ...state,
                deviceVitalDataECG: { ...deviceVitalDataECG }
            }

        };

        case Types.DEVICE_VITAL_DATA_SPO2: {

            //  console.log("DEVICE_VITAL_DATA_SPO2---------------->", action.payload);

            let bedId = action.payload.bedId;
            let patientMonitorId = action.payload.deviceId;
            // let dongleId = action.payload.dongleId;
            let deviceType = action?.payload?.deviceType?.toUpperCase();
            let vitals = action.payload.monitorParameter;

            if (!bedId || !patientMonitorId || !vitals) {
                return {
                    ...state
                }
            };

            let deviceVitalDataSPO2 = state.deviceVitalDataSPO2;
            deviceVitalDataSPO2[bedId] = {
                ...deviceVitalDataSPO2[bedId],
                // dongleId: dongleId,
                bedId: bedId,
                [deviceType]: {
                    patientMonitorId: patientMonitorId,
                    deviceType: deviceType,
                    vitals: vitals
                }
            }



            return {
                ...state,
                deviceVitalDataSPO2: { ...deviceVitalDataSPO2 }
            };

        }

        case Types.DEVICE_VITAL_DATA_TEMP: {

            //   console.log("DEVICE_VITAL_DATA_TEMP---------------->", action.payload);

            let bedId = action.payload.bedId;
            let patientMonitorId = action.payload.deviceId;
            // let dongleId = action.payload.dongleId;
            let deviceType = action?.payload?.deviceType?.toUpperCase();
            let vitals = action.payload.monitorParameter;

            if (!bedId || !patientMonitorId || !vitals) {
                return {
                    ...state
                }
            };

            let deviceVitalDataTEMP = state.deviceVitalDataTEMP;
            deviceVitalDataTEMP[bedId] = {
                ...deviceVitalDataTEMP[bedId],
                // dongleId: dongleId,
                bedId: bedId,
                [deviceType]: {
                    patientMonitorId: patientMonitorId,
                    deviceType: deviceType,
                    vitals: vitals
                }
            }

            return {
                ...state,
                deviceVitalDataTEMP: { ...deviceVitalDataTEMP }
            };
            break

        }

        case Types.DEVICE_VITAL_DATA_NIBP: {

            //   console.log("DEVICE_VITAL_DATA_NIBP---------------->", action.payload);

            let bedId = action.payload.bedId;
            let patientMonitorId = action.payload.deviceId;
            // let dongleId = action.payload.dongleId;
            let deviceType = action?.payload?.deviceType?.toUpperCase();
            let vitals = action.payload.monitorParameter;

            if (!bedId || !patientMonitorId || !vitals) {
                return {
                    ...state
                }
            };

            let deviceVitalDataNIBP = state.deviceVitalDataNIBP;
            deviceVitalDataNIBP[bedId] = {
                ...deviceVitalDataNIBP[bedId],
                // dongleId: dongleId,
                bedId: bedId,
                [deviceType]: {
                    patientMonitorId: patientMonitorId,
                    deviceType: deviceType,
                    vitals: vitals
                }
            }

            return {
                ...state,
                deviceVitalDataNIBP: { ...deviceVitalDataNIBP }
            };
            break

        }



        case Types.DEVICE_ECG_WAVEFORM_DATA: {
            //console.log("DEVICE_ECG_WAVEFORM_DATA---------------", action.payload)
            // // console.log("Redux_ECG_Packet_counter---------------", action?.payload?.eCGWaveform.counter)

            if (!action.payload) return state;
            let bedId = action?.payload?.bedId;
            let patientMonitorId = action?.payload?.deviceId;
            let dongleId = action?.payload?.dongleId;
            let deviceType = action?.payload?.deviceType?.toUpperCase();
            let eCGWaveform = action?.payload?.eCGWaveform;
            if (!(bedId && patientMonitorId && eCGWaveform)) return;

            //  console.log("ECG packet--------------------->", eCGWaveform)

            // const currentCounter = eCGWaveform.counter;
            // const deviceId = patientMonitorId;

            // if (lastEcgCounters[deviceId] !== undefined) {
            //     const expectedCounter = lastEcgCounters[deviceId] + 1;
            //     if (currentCounter === expectedCounter) {
            //         console.log(`✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅ Sequential ECG counter for ${deviceId}: ${currentCounter}`);
            //     } else {
            //         console.log(`❌❌❌❌❌❌❌❌❌❌❌❌❌❌❌❌❌ Non-sequential ECG counter for ${deviceId}: expected ${expectedCounter}, got ${currentCounter}`);
            //     }
            // } else {
            //     console.log(`ℹ️ First ECG counter received for ${deviceId}: ${currentCounter}`);
            // }

            // lastEcgCounters[deviceId] = currentCounter;
            // console.log(`lastEcgCounters----------------------->${JSON.stringify(lastEcgCounters)}`);








            let deviceEcgWaveform = state.deviceEcgWaveform
                || {};

            const existingWaveform = deviceEcgWaveform[bedId]?.[deviceType]?.waveform || {};



            const mergedWaveform = Object.keys(eCGWaveform).reduce((acc, key) => {
                if (!Array.isArray(eCGWaveform[key])) {
                    // console.warn(`Skipping non-array key: ${key} ->`, eCGWaveform[key]);
                    return acc; // Skip non-array keys like 'counter'
                }

                // Merge new data with existing waveform (if it exists)
                const updatedWaveform = Array.isArray(existingWaveform[key])
                    ? [...existingWaveform[key], ...eCGWaveform[key]]
                    : [...eCGWaveform[key]];

                // Keep only the latest 3000 points
                acc[key] = updatedWaveform.slice(-3000);

                return acc;
            }, {});



            // console.log("Merged--------------------->", mergedWaveform)


            deviceEcgWaveform[bedId] = {
                ...deviceEcgWaveform[bedId],
                dongleId: dongleId,
                bedId: bedId,
                [deviceType]: {
                    patientMonitorId: patientMonitorId,
                    deviceType: deviceType,
                    waveform: mergedWaveform,
                }
            }

            //  console.log(deviceEcgWaveform);

            return {
                ...state,
                deviceEcgWaveform: { ...deviceEcgWaveform },

            }
        }
        case Types.DEVICE_RESP_WAVEFORM_DATA: {


            if (!action.payload) return state;
            //  console.log("RESP packet-------------------------------->", action.payload);
            let bedId = action.payload.bedId;
            let patientMonitorId = action.payload.deviceId;
            let deviceType = action.payload.deviceType && action.payload.deviceType.toUpperCase();
            let RESP_waveform = action.payload.secondaryWaveforms;

            if (!bedId || !patientMonitorId || !RESP_waveform) return;
            let deviceRespWaveform = state.deviceRespWaveform || {};

            const existingWaveform = deviceRespWaveform[bedId]?.[deviceType]?.waveform || {};

            const mergedWaveform = Object.keys(RESP_waveform).reduce((acc, key) => {
                if (!Array.isArray(RESP_waveform[key])) {
                    return acc; // Skip non-array keys like 'counter'
                }

                // Merge new data with existing waveform (if it exists)
                const updatedWaveform = Array.isArray(existingWaveform[key])
                    ? [...existingWaveform[key], ...RESP_waveform[key]]
                    : [...RESP_waveform[key]];

                // Keep only the latest 3000 points
                acc[key] = updatedWaveform.slice(-3000);

                return acc;
            }, {});

            deviceRespWaveform[bedId] = {
                ...deviceRespWaveform[bedId],
                // dongleId: dongleId,
                bedId: bedId,
                [deviceType]: {
                    patientMonitorId: patientMonitorId,
                    deviceType: deviceType,
                    waveform: mergedWaveform,
                }
            }

            // console.log(deviceRespWaveform)


            return {
                ...state,
                deviceRespWaveform: { ...deviceRespWaveform }
            }

        }

        case Types.DEVICE_PLETH_WAVEFORM_DATA: {


            // if (!action.payload) return state;
            //  console.log("PLETH packet-------------------------------->", action.payload);
            let bedId = action.payload.bedId;
            let patientMonitorId = action.payload.deviceId;
            // let dongleId = action.payload.dongleId;
            let deviceType = action.payload.deviceType && action.payload.deviceType.toUpperCase();
            let PLETH_waveform = action.payload.secondaryWaveforms;

            if (!bedId || !patientMonitorId || !PLETH_waveform) return;
            let devicePlethWaveform = state.devicePlethWaveform || {};

            //     // // console.log(deviceWaveform);
            const existingWaveform = devicePlethWaveform[bedId]?.[deviceType]?.waveform || {};

            const mergedWaveform = Object.keys(PLETH_waveform).reduce((acc, key) => {
                if (!Array.isArray(PLETH_waveform[key])) {
                    return acc; // Skip non-array keys like 'counter'
                }

                // Merge new data with existing waveform (if it exists)
                const updatedWaveform = Array.isArray(existingWaveform[key])
                    ? [...existingWaveform[key], ...PLETH_waveform[key]]
                    : [...PLETH_waveform[key]];

                // Keep only the latest 3000 points
                acc[key] = updatedWaveform.slice(-1600);

                return acc;
            }, {});

            devicePlethWaveform[bedId] = {
                ...devicePlethWaveform[bedId],
                // dongleId: dongleId,
                bedId: bedId,
                [deviceType]: {
                    patientMonitorId: patientMonitorId,
                    deviceType: deviceType,
                    waveform: mergedWaveform,
                }
            }



            return {
                ...state,
                devicePlethWaveform: { ...devicePlethWaveform }
            }

        }
        default:
            return state;
    }
}

